import { Component, Input } from "@angular/core";
// Global, unencapsulated stylesheet: injected via this side-effect import, not Angular's
// styleUrls/styleUrl, so it isn't scoped to this component.
import "../../../scss/bank-icons.scss";

@Component({
  selector: "bank-icons",
  templateUrl: "./bank-icons.component.html",
})
export class BankIconsComponent {
  @Input() banks: string[];
  @Input() iconName = "more";
  @Input() svgClass = "tw-my-5 tw-h-4 tw-w-4 md:tw-my-2";
}
